import { lazy } from "react";
import HomePage from "../pages/HomePage";
import ReportPage from "../pages/ReportPage";
import HazmatReportPage from "../pages/HazmatReportPage";
import QRPosterPage from "../pages/QRPosterPage";
import CocPage from "../pages/CocPage";
import ContractorDownloadPage from "../pages/ContractorDownloadPage";
import EndpointPage from "../../pages/EndpointPage";
import QRPage from "../pages/QRPage";
import ClearanceReportPage from "../pages/ClearanceReportPage";
import NotFoundPage from "../../pages/NotFoundPage";

// use lazy for better code splitting, a.k.a. load faster
// const EndpointPage = lazy(() => import("../../pages/EndpointPage"));
// const HomePage = lazy(() => import("../pages/HomePage"));
// const CocPage = lazy(() => import("../pages/CocPage"));
// const ReportPage = lazy(() => import("../pages/ReportPage"));
// const HazmatReportPage = lazy(() => import("../pages/HazmatReportPage"));

/**
 * ⚠ These are internal routes!
 * They will be rendered inside the app, using the default `containers/Layout`.
 * If you want to add a route to, let's say, a landing page, you should add
 * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
 * are routed.
 *
 * If you're looking for the links rendered in the SidebarContent, go to
 * `routes/sidebar.js`
 */
const routes = [
  {
    path: "",
    component: HomePage,
  },
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/docs/report/:id",
    component: ReportPage,
  },
  {
    path: "/docs/hazmat-register/:id",
    component: HazmatReportPage,
  },
  {
    path: "/docs/qr-poster",
    component: QRPage,
  },
  {
    path: "/docs/qr-poster/:id",
    component: QRPosterPage,
  },
  {
    path: "/docs/hazmat-building-report-qrcode/:id",
    component: ContractorDownloadPage,
  },
  {
    // This is the URL printed inside the QR posters — keep it stable.
    path: "/docs/contractor-download/:id",
    component: ContractorDownloadPage,
  },
  {
    path: "/docs/coc/:id",
    component: CocPage,
  },
  {
    path: "/docs/clearance-report/:id",
    component: ClearanceReportPage,
  },
  {
    path: "/:namespace/view/",
    component: HomePage,
  },
  {
    path: "/:namespace/edit/",
    component: HomePage,
  },
  {
    path: "/:namespace/delete/",
    component: HomePage,
  },
  {
    path: "/:namespace/:action/:id",
    component: EndpointPage,
  },
  {
    path: "/:namespace/:action",
    component: EndpointPage,
  },
  {
    path: "/:namespace",
    component: EndpointPage,
  },
  {
    path: "*",
    component: NotFoundPage,
  },
];

export default routes;
